import { asSingleStyleConfig } from '../../../../utils/theme';
var baseStyleText = {
  color: '#1f1f1f',
  fontWeight: 400,
  py: 2,
  fontSize: 'md',
  px: 3,
  borderLeft: '3px solid',
  borderColor: 'red.500',
  bg: 'red.100'
};
var baseStyleIcon = {
  color: '#1f1f1f'
};
var baseStyle = {
  text: baseStyleText,
  icon: baseStyleIcon
};
export var FormError = asSingleStyleConfig({
  baseStyle
});